import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { Navbar } from "../components/Navbar";
import { useAuth } from "../context/AuthContext";
import { formatApiErrorDetail } from "../lib/data";
import { LineChart, Gift } from "lucide-react";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const ref = params.get("ref");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      const u = await register(name, email, password, ref);
      navigate(u.role === "admin" ? "/admin" : "/members");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally { setLoading(false); }
  };

  return (
    <div>
      <Navbar />
      <div className="max-w-md mx-auto px-6 py-20">
        <LineChart className="h-8 w-8 text-[#00B368] mb-4" />
        <h1 className="font-display text-3xl tracking-tight text-[#0A1914] mb-2">Create your account</h1>
        <p className="text-sm text-gray-600 mb-6">Join thousands of members earning weekly while they learn to trade.</p>
        {ref && (
          <div className="flex items-center gap-2 bg-[#00B368]/10 border border-[#00B368]/30 text-[#0A1914] text-sm px-4 py-2.5 rounded-sm mb-6" data-testid="referral-banner">
            <Gift className="h-4 w-4 text-[#00B368]" /> You were invited by a member — welcome!
          </div>
        )}
        <form onSubmit={submit} className="space-y-4" data-testid="register-form">
          <div>
            <label className="text-xs font-mono uppercase tracking-wider text-gray-500">Full name</label>
            <input data-testid="register-name" required value={name} onChange={(e) => setName(e.target.value)} className="w-full mt-1 border border-gray-300 rounded-sm px-3 py-2.5 focus:border-[#00B368] focus:ring-1 focus:ring-[#00B368]/20 outline-none" />
          </div>
          <div>
            <label className="text-xs font-mono uppercase tracking-wider text-gray-500">Email</label>
            <input data-testid="register-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="w-full mt-1 border border-gray-300 rounded-sm px-3 py-2.5 focus:border-[#00B368] focus:ring-1 focus:ring-[#00B368]/20 outline-none" />
          </div>
          <div>
            <label className="text-xs font-mono uppercase tracking-wider text-gray-500">Password</label>
            <input data-testid="register-password" type="password" required minLength={6} value={password} onChange={(e) => setPassword(e.target.value)} className="w-full mt-1 border border-gray-300 rounded-sm px-3 py-2.5 focus:border-[#00B368] focus:ring-1 focus:ring-[#00B368]/20 outline-none" />
          </div>
          {error && <p data-testid="register-error" className="text-sm text-red-600">{error}</p>}
          <button data-testid="register-submit" disabled={loading} className="w-full bg-[#0A1914] text-white py-3 rounded-sm hover:bg-[#00B368] transition-colors disabled:opacity-50">{loading ? "Creating..." : "Create account"}</button>
        </form>
        <p className="text-sm text-gray-600 mt-6">Already a member? <Link to="/login" className="text-[#00B368] hover:underline">Log in</Link></p>
      </div>
    </div>
  );
}
